import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const SelectFlap = ( { id, setId, drawing, onFlap, theme, as, title, isLast, image, rotate, disabled: externalDisabled} ) => {
  const dropdownRef = useRef(null);
  const [disabled, setDisabled] = useState(externalDisabled !== undefined ? externalDisabled : true);
  const [visuallyDisabled, setVisuallyDisabled] = useState(externalDisabled !== undefined ? externalDisabled : true);
  const enableTimeoutRef = useRef(null);

  const handleClick = (e, option) => {
    e.preventDefault();

    if(drawing[as].id == option.id) {
      return;
    }
    setId( () => option.drawing_id )
  }

  const asOption = (option) => {
    return <div className={`${styles.tp_dropdown_item}`} key={option.drawing_id} onClick={ (e) => { handleClick(e,  option ) } }>
      <a className={`dropdown-item ${styles.tp_dropdown_item_a}`} href="#" onClick={ (e) => { handleClick(e,  option ) } }>
        <img style={{ width: "88px" }} className={`${rotate ? 'rotate180' : ''} additional_feature_img tag_img_${theme}`} src={`https://d2atdwxjx7uc4i.cloudfront.net/images/tags/${image}_${option.id}.png`} />
        <span className={`${styles.tp_value}`}> <input type="radio" readOnly checked={drawing[as].id == option.id} /> {option.name} </span>
      </a>
    </div>
  }

  const scrollDropdownIntoView = () => {
    if (dropdownRef.current) {
      // Find the dropdown menu element
      const dropdownMenu = dropdownRef.current.querySelector('.dropdown-menu');

      // Find the scrollable container - try multiple selectors
      let container = document.getElementById('technical_properties_left');

      // If no container found by ID, try by class
      if (!container) {
        container = document.querySelector(`[class*="${styles.tp_left}"]`) ||
                   document.querySelector('[class*="tp_left"]') ||
                   document.querySelector('.modal-body') ||
                   dropdownRef.current.closest('[class*="tp_left"]');
      }

      if (container && dropdownMenu) {
        // Check if dropdown is visible (display is not 'none' and has height)
        const dropdownStyles = window.getComputedStyle(dropdownMenu);
        const isVisible = dropdownStyles.display !== 'none' && dropdownMenu.offsetHeight > 0;

        if (isVisible) {
          // Get the dropdown toggle element position to scroll relative to it
          const toggleElement = dropdownRef.current.querySelector('.dropdown-toggle');
          if (toggleElement) {
            const toggleRect = toggleElement.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const dropdownRect = dropdownMenu.getBoundingClientRect();

            // Calculate how much of the dropdown is below the container
            const belowAmount = dropdownRect.bottom - containerRect.bottom;

            // If dropdown extends below the container, scroll it into view
            if (belowAmount > 0) {
              // Smooth scroll the container to show the entire dropdown
              const targetScrollTop = container.scrollTop + belowAmount + 30; // Add extra padding
              $(container).animate({ scrollTop: targetScrollTop }, 300);
              return;
            }

            // Also check if we need to scroll to show the toggle element
            if (toggleRect.bottom > containerRect.bottom - 200) {
              // If the toggle is too close to bottom, scroll to give more space
              const scrollAmount = toggleRect.bottom - containerRect.bottom + 250;
              const targetScrollTop = container.scrollTop + scrollAmount;
              $(container).animate({ scrollTop: targetScrollTop }, 300);
            }
          }
        }
      }
    }
  };

  const setDropDown = () => {
    $(".dropdown-menu").width( $(".input_tp").css('width') )
    $(".dropdown-menu").css("margin-left",  (-1 * (parseFloat($(".input_tp").css('width')) - 60)) + "px" )

    // Auto-scroll when dropdown is shown with increased delay for rendering
    setTimeout(scrollDropdownIntoView, 100);

    setTimeout(setDropDown, 200)
  }

  useEffect(setDropDown, [id] )

  // Sync external disabled prop with internal state
  useEffect(() => {
    if (externalDisabled !== undefined) {
      setDisabled(externalDisabled);

      // Clear any pending enable timeout
      if (enableTimeoutRef.current) {
        clearTimeout(enableTimeoutRef.current);
        enableTimeoutRef.current = null;
      }

      if (externalDisabled) {
        // When disabling, apply immediately
        setVisuallyDisabled(true);
      } else {
        // When enabling, delay the visual state by 200ms
        enableTimeoutRef.current = setTimeout(() => {
          setVisuallyDisabled(false);
          enableTimeoutRef.current = null;
        }, 250);
      }
    }
  }, [externalDisabled]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (enableTimeoutRef.current) {
        clearTimeout(enableTimeoutRef.current);
      }
    };
  }, []);

  // Handle dropdown toggle events
  useEffect(() => {
    const handleDropdownToggle = () => {
      // Use longer timeout to ensure dropdown is fully rendered
      setTimeout(scrollDropdownIntoView, 100);
    };

    const dropdownElement = dropdownRef.current;
    if (dropdownElement) {
      // Listen for Bootstrap dropdown events on the dropdown toggle
      const toggleElement = dropdownElement.querySelector('.dropdown-toggle');
      if (toggleElement) {
        $(toggleElement).parent().on('shown.bs.dropdown', handleDropdownToggle);

        return () => {
          $(toggleElement).parent().off('shown.bs.dropdown', handleDropdownToggle);
        };
      }
    }
  }, []);

  if (drawing[as] == undefined) { return }

  return (
    <div key={drawing.id} className={`${styles.input_tp} input_tp`}>

       <span className={`${isLast ? styles.last_tag : ''}`} >

            <span className={`${styles.label}`}> {title} </span>

            <div className={`${styles.floatRight}`}>

                { drawing[as].name }  &nbsp;

                <span className={` ${styles.tp_dropdown} ${visuallyDisabled ? styles.disabled : ''} dropdown`} ref={dropdownRef}>

                  <a
                    className="dropdown-toggle"
                    type="button"
                    href="#"
                    id="imageDropdown"
                    data-toggle={visuallyDisabled ? "" : "dropdown"}
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ opacity: visuallyDisabled ? 0.5 : 1, cursor: visuallyDisabled ? 'not-allowed' : 'pointer' }}
                    onClick={(e) => { if (visuallyDisabled) e.preventDefault(); }}
                  >
                    <i className="fa fa-pencil-square-o"></i>  {t('models.change')}
                  </a>

                  {!visuallyDisabled && (
                    <div className={` ${styles.tp_dropdown_menu} dropdown-menu`} aria-labelledby="imageDropdown">
                      {(onFlap.concat( [drawing[as]] ) ).sort((a, b) => a.id - b.id).map(asOption)}
                    </div>
                  )}
              </span>
          </div>
      </span>

  </div>);

}

export default SelectFlap;
